/* ==========================================================================
   Giftogy photo handoff — carries uploaded photo files from the
   "photo-upload" section, across a full-page redirect, to a matching
   widget on the product page.

   Why IndexedDB: a URL redirect can't carry real File/Blob objects (only
   strings via query params). localStorage/sessionStorage also can't hold
   Blobs. IndexedDB can — so we stash the files there right before
   navigating, then read them back on the next page. It's purely
   client-side (same browser, same device), no backend/app required.
   ========================================================================== */
(function (global) {
  var DB_NAME = 'giftogy_photo_handoff';
  var STORE = 'photos';
  var KEY = 'pending';

  function openDb() {
    return new Promise(function (resolve, reject) {
      if (!('indexedDB' in window)) {
        reject(new Error('IndexedDB not supported'));
        return;
      }
      var req = indexedDB.open(DB_NAME, 1);
      req.onupgradeneeded = function (e) {
        e.target.result.createObjectStore(STORE);
      };
      req.onsuccess = function (e) { resolve(e.target.result); };
      req.onerror = function (e) { reject(e); };
    });
  }

  function save(files) {
    return openDb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction(STORE, 'readwrite');
        var store = tx.objectStore(STORE);
        // Store as plain array of Blobs + names (Files are Blobs with a name)
        var payload = files.map(function (f) {
          return { blob: f, name: f.name, type: f.type };
        });
        store.put(payload, KEY);
        tx.oncomplete = function () { resolve(); };
        tx.onerror = function (e) { reject(e); };
      });
    });
  }

  function load() {
    return openDb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction(STORE, 'readonly');
        var store = tx.objectStore(STORE);
        var req = store.get(KEY);
        req.onsuccess = function () {
          var payload = req.result;
          if (!payload || !payload.length) {
            resolve([]);
            return;
          }
          // Rehydrate into real File objects
          var files = payload.map(function (p) {
            try {
              return new File([p.blob], p.name, { type: p.type });
            } catch (err) {
              // Safari fallback: File constructor with Blob works in modern
              // versions; if it fails, just use the Blob directly.
              return p.blob;
            }
          });
          resolve(files);
        };
        req.onerror = function (e) { reject(e); };
      });
    });
  }

  function clear() {
    return openDb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction(STORE, 'readwrite');
        tx.objectStore(STORE).delete(KEY);
        tx.oncomplete = function () { resolve(); };
        tx.onerror = function (e) { reject(e); };
      });
    });
  }

  global.GiftogyPhotoHandoff = {
    save: save,
    load: load,
    clear: clear
  };
})(window);